'use strict'

export const nivelCampanha = {
    VISUALIZACAO:'data_visualizacao',
    CLICK:'data_click',
    CONTRATACAO:'data_contratacao'
}

export const linkCampanha = {
    CADASTRO:'cadastro',
    EMPRESTIMO:'simulador-emprestimo',
    RENDA:'simulador-renda',
    SEGURO:'simulador-seguro',
    APORTE: 'simulador-aporte'
}

export default class campanhaEnum {}